// Adds an "s" to a string if the number provided is anything other than 1 or -1

export default function pluralize(str, num = 0) {
  if (num === 1) return str
  if (str.endsWith('s')) return str + 'es'
  return str + 's'
}
